import { isElement } from 'libraries/lodash'
import { getParentElement } from 'libraries/front-end-core/helpers/document'

export const getNode = (condition: (element: HTMLElement) => boolean): (element: HTMLElement | null) => HTMLElement | false => {
  const inner = (element: HTMLElement | null): HTMLElement | false => {
    if (element === null || !isElement(element)) {
      return false
    }
    if (condition(element)) {
      return element
    }
    return inner((getParentElement(element) as HTMLElement))
  }
  return inner
}

export const isLink = getNode((element: HTMLElement) => element.tagName === 'A')

export const isInView = (el: HTMLElement, partiallyVisible = true): boolean => {
  const { top, left, bottom, right } = el.getBoundingClientRect()
  const { innerHeight, innerWidth } = window

  return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
}
